import { PropsWithChildren } from "react";
import { css, Theme, useTheme } from "@emotion/react";
import { Button } from "../../general/Button/Button";
import { Text } from "../../general/Text";

export const PercentageButton = ({
  children,
  onClick,
  isActive,
}: PropsWithChildren<{ onClick: () => void; isActive: boolean }>) => {
  const theme = useTheme();
  return (
    <Button
      textSize="Medium"
      buttonCss={percentageButtonCss(isActive, theme)}
      onClick={() => !isActive && onClick()}
    >
      <Text textStyle="Button" size="Medium">
        {children}
      </Text>
    </Button>
  );
};

const percentageButtonCss = (isActive: boolean, theme: Theme) => css`
  display: flex;
  padding: 12px 14px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
  border-radius: 14px;
  color: ${isActive
    ? theme.button.selector.text["active-hover"]
    : theme.button.selector.text.default};
  transform:
    background linear 0.2s,
    color linear 0.2s;

  background: ${isActive
    ? theme.button.selector.surface["active-hover"]
    : theme.button.quaternary.surface.default};

  cursor: ${isActive ? "default" : "pointer"} !important;

  &:hover {
    background: ${isActive
      ? theme.button.selector.surface["active-hover"]
      : theme.button.quaternary.surface.hover};
    color: ${isActive
      ? theme.button.selector.text["active-hover"]
      : theme.button.selector.text.default};
  }
`;
